import lightToken from "themes/light.json";
import qerpOverrides from "./qerp.json";

type ComponentTokens = Record<string, Record<string, unknown>>;
type ThemeFile = { components: ComponentTokens } & Record<string, unknown>;

const isQerp = (): boolean =>
  typeof document !== "undefined" && document.body.classList.contains("qerp-theme");

export const getAntdConfigProps = () => {
  const { components: lightComponents, ...lightGlobals } = lightToken as unknown as ThemeFile;

  if (!isQerp()) {
    return { theme: { components: lightComponents, token: lightGlobals } };
  }

  const { components: qerpComponents, ...qerpGlobals } = qerpOverrides as unknown as ThemeFile;
  const mergedComponents: ComponentTokens = { ...lightComponents };
  Object.entries(qerpComponents).forEach(([name, overrides]) => {
    mergedComponents[name] = { ...(lightComponents?.[name] ?? {}), ...overrides };
  });

  return {
    theme: { components: mergedComponents, token: { ...lightGlobals, ...qerpGlobals } },
  };
};
